"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
/**
 * This method creates or clones a new instance of a given component class/instance
 * and adds arbitrary props to it.
 */
function patchIcon(Icon, props) {
    var patchedIcon = null;
    if (React.isValidElement(Icon)) {
        var patchedProps = __assign(__assign({}, (props || {})), { className: classNames(Icon.props.className, props && props.className) });
        patchedIcon = React.cloneElement(Icon, patchedProps);
    }
    else if (typeof Icon === 'function') {
        var Comp = Icon;
        patchedIcon = React.createElement(Comp, __assign({}, props));
    }
    return patchedIcon;
}
exports.default = patchIcon;
//# sourceMappingURL=patchIcon.js.map